// Mirror of backend mp_calc / mp_recommend (server.py) — keep formulas identical.
export const MP_KEYS = ['shopee', 'tiktok', 'minimo'];

export const FEE_DEFAULTS = {
  shopee: { proses: 1250, admin_pct: 10, admin_max: 10_000_000, ongkir_pct: 8,   ongkir_max: 40_000,     pph_pct: 0.5 },
  tiktok: { proses: 1940, admin_pct: 10, admin_max: 10_000_000, ongkir_pct: 6.5, ongkir_max: 10_000_000, pph_pct: 0.5 },
  minimo: { proses: 1250, admin_pct: 10, admin_max: 1_000_000,  ongkir_pct: 0,   ongkir_max: 0,          pph_pct: 0 },
};

export const ADDON_MASTER_DEFAULTS = [
  { name: 'Raket Saja',    price: 0 },
  { name: 'BG 66 Ultimax', price: 90_000 },
  { name: 'Exbolt 65',     price: 90_000 },
  { name: 'BG 80',         price: 90_000 },
  { name: 'Aerobite',      price: 100_000 },
  { name: 'Packing',       price: 10_000 },
];

export const rp = (x) => {
  const n = Number(x) || 0;
  return n >= 0 ? Math.floor(n + 0.5) : -Math.floor(-n + 0.5);
};
const cap = (val, mx) => (mx && mx > 0 ? Math.min(val, mx) : val);
const KEYS = ['bruto', 'hpp', 'admin', 'ongkir', 'proses', 'pph', 'packing',
  'total_potongan', 'total_biaya', 'neto', 'profit'];

export function mpCalc(harga, hpp, fee, { orders = 1, packing = 0, adminBase, ongkirBase, pajakBase } = {}) {
  const n = Math.max(parseInt(orders, 10) || 1, 1);
  const bruto = rp(harga);
  if (bruto <= 0) {
    const zero = Object.fromEntries(KEYS.map((k) => [k, 0]));
    return { ...zero, margin: 0, orders: n, total: { ...zero } };
  }
  const has = (v) => v !== undefined && v !== null && v !== '';
  const aBase = has(adminBase) ? rp(adminBase) : bruto;
  const oBase = has(ongkirBase) ? rp(ongkirBase) : bruto;
  const pBase = has(pajakBase) ? rp(pajakBase) : bruto;
  const admin = rp(cap(aBase * (Number(fee.admin_pct) || 0) / 100, Number(fee.admin_max) || 0));
  const ongkir = rp(cap(oBase * (Number(fee.ongkir_pct) || 0) / 100, Number(fee.ongkir_max) || 0));
  const proses = rp(fee.proses || 0);
  const pph = rp(pBase * (Number(fee.pph_pct) || 0) / 100);
  const hppR = rp(hpp);
  const pack = rp(packing);
  const total_potongan = admin + ongkir + proses + pph;
  const neto = bruto - total_potongan;
  const profit = neto - hppR - pack;
  const per = {
    bruto, hpp: hppR, admin, ongkir, proses, pph, packing: pack, total_potongan,
    total_biaya: total_potongan + hppR + pack, neto, profit,
  };
  return {
    ...per,
    margin: Math.round((profit / bruto) * 10000) / 100,
    orders: n,
    total: Object.fromEntries(KEYS.map((k) => [k, per[k] * n])),
  };
}

export function mpRecommend(hpp, fee, mode, target, packing = 0) {
  const h = Number(hpp) || 0;
  const pk = Number(packing) || 0;
  const t = Number(target) || 0;
  const need = (p) => (mode === 'margin' ? (p * t) / 100 : mode === 'markup' ? (h * t) / 100 : t);
  const ok = (p) => mpCalc(p, h, fee, { packing: pk }).profit >= need(p) - 1e-9;
  let hi = Math.max(Math.floor(h + pk + Math.max(t, 0)) + 1, 1);
  while (!ok(hi)) {
    hi *= 2;
    if (hi > 1e12) return null;
  }
  let lo = 0;
  while (lo < hi) {
    const mid = Math.floor((lo + hi) / 2);
    if (ok(mid)) hi = mid; else lo = mid + 1;
  }
  return { price: lo, target_profit: rp(need(lo)), breakdown: mpCalc(lo, h, fee, { packing: pk }) };
}
